import {differenceInMinutes, isValid, parseISO, subMinutes} from 'date-fns';

export function parseToUTC(dateStr: string, offsetMinutes): Date | null {
  const date = parseISO(dateStr);
  if (!isValid(date)) {
    return null;
  }

  return subMinutes(date, offsetMinutes);
}

export function isOlderThan(utcDate: Date | null, minutes: number): boolean {
  if (!utcDate) return false;

  const nowUtc = new Date();
  const diff = differenceInMinutes(nowUtc, utcDate);

  return diff > minutes;
}
